import React, { useEffect } from 'react';

/**
 * Bottom sheet for the compact (phone) shell. Sits above the bottom nav
 * so the scene stays in view and the sheet itself is never clipped.
 */
export default function MobileSheet({
  open = true,
  title,
  onClose,
  children,
  height = '62dvh',
  zIndex = 90,
  footer = null,
  aboveNav = false,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={`mdv-mobile-sheet-root ${aboveNav ? 'mdv-sheet-lift' : ''}`} style={{ zIndex }} role="presentation">
      <button
        type="button"
        className="mdv-mobile-sheet-backdrop"
        aria-label="Close panel"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-label={title || 'Panel'}
        className="mdv-mobile-sheet"
        style={{ maxHeight: height }}
      >
        <div className="mdv-mobile-sheet-handle" aria-hidden>
          <span />
        </div>
        <div className="mdv-mobile-sheet-head">
          {title ? (
            <h2 className="mdv-mobile-sheet-title">{title}</h2>
          ) : (
            <span />
          )}
          {onClose ? (
            <button
              type="button"
              className="mdv-mobile-sheet-close"
              onClick={onClose}
              aria-label={`Close ${title || 'panel'}`}
            >
              Close
            </button>
          ) : null}
        </div>
        <div className="mdv-mobile-sheet-body">{children}</div>
        {footer}
      </div>
    </div>
  );
}
